import React, { useEffect, useState } from "react";
import { Form, Input, DatePicker, Select, InputNumber, Upload, Button, Typography, Row, Col } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { ServicetypeService } from "../../../../Services/Manage/ServicetypeService";
import { ExpenseServices } from "../../../../Services/Manage/ExpenseServices";
import useMessage from "antd/es/message/useMessage";

const { TextArea } = Input;
const { Title } = Typography;

const AddSingleExpense = ({activeBillType, getAllExpense, onClose}) => {
  const [form] = Form.useForm();
  const [vendorOption, setVendorOption] = useState([]);
  const [lastPO, setLastPO] = useState("");
  const [fileList, setFileList] = useState([]);
  const [message, msgContx] =useMessage();

  const generateNextPO = (lastPOValue) => {
    const currentYear = new Date().getFullYear();

    if (!lastPOValue) {
      return `BILL-${currentYear}-001`;
    }

    const match = lastPOValue.match(/^BILL-(\d{4})-(\d+)$/);

    if (!match) {
      return `BILL-${currentYear}-001`;
    }

    const [_, yearStr, numberStr] = match;
    const year = parseInt(yearStr);
    const number = parseInt(numberStr);

    if (year === currentYear) {
      const nextNumber = number + 1;
      return `BILL-${year}-${String(nextNumber).padStart(3, "0")}`;
    } else {
      // New year → reset counter
      return `BILL-${currentYear}-001`;
    }
  };

  console.log(activeBillType);
  

  const lastAddedPO = async () => {
    try {
      const response = await ServicetypeService.lastAddedBillId();
      const lastPOValue = response?.data?.bill_id;
      const newPO = generateNextPO(lastPOValue);
      setLastPO(newPO);
      // setPoId(newPO);
      form.setFieldsValue({ bill_id: newPO });
    } catch (error) {
      console.error("Error fetching last PO:", error);
      const newPO = generateNextPO(null);
      setLastPO(newPO);
      form.setFieldsValue({ bill_id: newPO });
      // setPoId(newPO);
    }
  };

useEffect(() => {
  if (!activeBillType) return;
  lastAddedPO();
}, [activeBillType]);


  const onFinish = async (values) => {
    console.log("Form Values:", values);
      if (!activeBillType) return; 
    const saveEx = {
      ...values,
      bill_id: lastPO,
      bill_type: activeBillType
    }

    console.log(saveEx);

    // const formattedData = dataSource.map(({ key, ...rest }) => ({
    //                 ...rest,
    //                 added_by: user.uid,
    //                 type: "bill",
    //                 vendor_id: vendorId,
    //                 category: category,
    //                 bill_id: poId,
    //                 bill_type: activeBillType
    //             }));

    const request = await ExpenseServices.createExpense(saveEx);

 if (request.status) {
  message.success(request.message);

  // ✅ RESET OLD VALUES
  form.resetFields();
  setFileList([]);

  // ✅ GENERATE NEW BILL ID
  await lastAddedPO();

  onClose();
  getAllExpense();
}
 else {
      message.error(request.message);
    }

  };

  const GetAllVendors = async () => {
      try {
        const request = await ServicetypeService.getAllVendors();
        setVendorOption(
          request.data.map((item, index) => ({
            label: item.name,
            value: item.id,
          }))
        );
      } catch (error) {
        console.error(error);
      }
    };
  

    useEffect(() => {
      GetAllVendors();
    }, []);

  return (
    <div style={{ padding: 20, margin: "0 auto" }}>
      {msgContx}
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Row gutter={20}>
          {/* Left Column */}
          <Col xs={24} md={12}>

      <Form.Item label="Bill ID" name="bill_id">
  <Input size="large" readOnly />
</Form.Item>


            <Form.Item
              name="date"
              label="Date"
              rules={[{ required: true, message: "Please select a date" }]}
            >
              <DatePicker size="large" style={{ width: "100%" }} allowClear />
            </Form.Item>

            <Form.Item name="source_of_supply" label="Source of Supply">
              <Input size="large" placeholder="Enter source" allowClear />
            </Form.Item>

            <Form.Item
              name="category"
              label="Category"
              rules={[{ required: true, message: "Please enter category" }]}
            >
              <Input size="large" placeholder="Enter category" allowClear />
            </Form.Item>
          </Col>

          {/* Right Column */}
          <Col xs={24} md={12}>
            <Form.Item name="asset_name" label="Asset Name">
              <Input size="large" placeholder="Enter Asset Name" allowClear />
            </Form.Item>

            <Form.Item
              name="vendor_id"
              label="Vendor Name"
              rules={[{ required: true, message: "Please select vendor" }]}
            >
              <Select size="large" placeholder="Select vendor" allowClear options={vendorOption} />
            </Form.Item>

            <Form.Item
              name="totalprice"
              label="Amount"
              rules={[{ required: true, message: "Please enter amount" }]}
            >
              <InputNumber
                size="large"
                style={{ width: "100%" }}
                placeholder="Enter amount"
                min={0}
                
              />
            </Form.Item>
          </Col>
        </Row>

        {/* Full-width Fields */}
        <Row gutter={20}>
          <Col span={24}>
            <Form.Item name="comments" label="Comments">
              <TextArea size="large" rows={3} placeholder="Enter comments" allowClear />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item name="attachment" label="Attachment">
              <Upload
                fileList={fileList}
                onChange={({ fileList }) => setFileList(fileList)}
                beforeUpload={() => false}
              >
                <Button icon={<UploadOutlined />}>Upload</Button>
              </Upload>

            </Form.Item>
          </Col>
        </Row>

        {/* <Form.Item>
          <Button size="large" type="primary" htmlType="submit">
            Save Expense
          </Button>
        </Form.Item> */}
      </Form>
    </div>
  );
};

export default AddSingleExpense;